import { useQuery } from 'react-query';
import { service } from '../redux/api/axios';
import HookTypes from '../redux/types/hooks';

const useHook = () => {
  return useQuery([HookTypes.topics_admin], async () => {
    const response = await service.get('/topics/admin');
    return response.data;
  });
};

export default useHook;
